import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

const ScrollTopAlways: React.FC = () => {
	const location = useLocation();

	React.useEffect(() => {
		window.scrollTo(0, 0);
		document.querySelector('#react-app')?.scrollTo(0, 0);
	}, [location]);

	return <Outlet />;
};

export default ScrollTopAlways;
